import React from 'react';
import SelectInput from './SelectInput';

const MultiSelectInput = ({ argument, onChange }) => {
  // Multi-select is like select but with multiple selection enabled
  const multiSelectArgument = {
    ...argument,
    options: {
      ...argument.options,
      permitMultiple: true,
    },
  };

  return <SelectInput argument={multiSelectArgument} onChange={onChange} />;
};

export default MultiSelectInput;
